<template>
    <div class="whole_div">
        <van-cell v-if="title" :border="false" :is-link="showRight" >
            <div slot="title" style="height: 30px; ">
                <span style="font-size: 16px; font-weight: bold">{{title}}</span>
                <span v-if="sub_title" style="font-size: 16px; font-weight: bold">{{sub_title}}</span>
                <van-icon v-if="datas && datas.length > 0 && showEye" :name="eye_icon_name" size="20px"
                          style="position: absolute; top: 13px; margin-left: 10px;"
                          @click="eyeIconClick"/>

                <van-icon v-if="datas && datas.length > 0 && showQuestion" name="question-o" size="20px"
                          style="position: absolute; top: 13px; margin-left: 45px;" color="#1989fa"
                          @click="questionIconClick"/>
            </div>
            <div v-if="showRight" slot="default" @click="clickCell">
                详情
            </div>

        </van-cell>

        <van-divider style="margin-top: 0px; margin-bottom: 0px"/>
        <div style="">
            <slot name="top">
                <div v-if="datas && datas.length > 0">
                    <div v-for="(item, index) in datas" :key="index" style="text-align: center;">
                        <van-col :span="getColSpan(datas)">
                            <div style="background-color: white; padding-top: 20px; padding-bottom: 20px;">
                                <div :style="{'border-left': initBorderLeft(index)}">

                                    <div v-if="show_number" style="font-weight: bold; font-size: 15px; color: #FF0000">
                                        <span v-if="item.count_unit === '￥'">
                                            {{item.count_unit}}{{item.count}}
                                        </span>
                                        <span v-else>
                                            {{item.count}}{{item.count_unit}}
                                        </span>
                                    </div>
                                    <div v-else style="font-weight: bold; font-size: 15px; color: #FF0000">
                                        ****
                                    </div>

                                    <div style="" v-html="item.text"></div>
                                </div>
                            </div>
                        </van-col>

                    </div>
                </div>
            </slot>
        </div>

        <div >
            <slot name="bottom">
                <van-row>
                </van-row>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Wp_mini_data_card",
        props:{
            title:{type:String, default:""},
            sub_title:{type:String, default:""},
            datas:{
                type:Array,
                default:null
            },
            showRight:{type: Boolean, default: true},
            showEye:{type: Boolean, default: true},
            showQuestion:{type: Boolean, default: false},
            questionContent:{type:String, default:""},
        },

        data(){
            return{
                col_span: 8,
                count_field: 0,
                field_type:"number",
                eye_icon_name: "eye-o",
                show_number: true,
            }
        },

        created() {
            if(this.datas){
                // if(this.datas.length === 2){
                //     this.col_span = 12;
                // }else if(this.datas.length === 3){
                //     this.col_span = 8;
                // }else if(this.datas.length === 4){
                //     this.col_span = 6;
                // }
                if(this.datas.length >= 2){
                    this.col_span = 24 / this.datas.length;
                }
            }
        },

        methods:{

            questionIconClick(){
                // this.$emit("clickQuestion")
                if(this.questionContent){
                    this.$dialog.alert({
                        message: this.questionContent
                    })
                }
            },

            eyeIconClick(){
                if(this.show_number){
                    this.eye_icon_name = "closed-eye";
                    this.show_number = false;
                }else{
                    this.eye_icon_name = "eye-o";
                    this.show_number = true;
                }
            },

            /**
             * 获取van-col的span的值
             */
            getColSpan(datas){
                if(datas.length > 0){
                    this.col_span = 24 / datas.length;
                }
                return this.col_span;
            },

            /**
             * 点击单元格
             */
            clickCell(){
                this.$emit("clickMore")
            },

            /**
             * 设置中间分割线
             * @param index
             * @return {string}
             */
            initBorderLeft(index){
                if(index !== 0){
                    return "1px solid #eeeeee";
                }
            }
        }
    }
</script>

<style scoped>
    .whole_div{
        background-color: white;
        /*min-height: 150px;*/
        /*padding-top: 15px;*/
        /*padding-bottom: 15px;*/

        box-shadow: 1px 1px 5px #999999;
    }
</style>